import React from "react";
import { useAuth } from "./context/AuthContext";
import AppRouter from "./Router";
import BackgroundPortal from "./components/global/BackgroundPortal";
import StatusMessage from "./components/shared/StatusMessage";

const App = () => {
  const { user } = useAuth();

  return (
    <>
      {user.id !== null && <BackgroundPortal />}
      <StatusMessage />
      <div className="relative z-10 text-text-muted font-oxanium">
        <AppRouter />
      </div>
    </>
  );
};

export default App;
